export default __webpack_public_path__ + "static/media/225.96b30041.png";